var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _polygon, _polygon2, _circle4, _rect35, _rect36, _polygon3, _polygon4, _circle5, _path8, _path9, _path10, _rect37, _rect38, _rect39, _rect40, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _rect41, _path11, _path12, _rect42, _circle6, _path13, _polygon10, _polygon11, _polygon12, _path14, _path15, _path16, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _path17, _path18, _circle7, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle8, _path26, _path27, _path28, _polygon13, _polygon14, _polygon15, _polygon16, _path29, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ea61258a-e793-48f7-8624-3c5ca462ffd9",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 882.34637,
    height: 778.99856,
    viewBox: "0 0 882.34637 778.99856",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "remotely") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M501.18877,80.56067l3.46953-5.362a80.3872,80.3872,0,0,0-3.55952-8.33251l-2.24352,1.81205,1.77642-2.74534c-1.69294-3.3325-3.02505-5.43215-3.02505-5.43215s-6.95827,10.96511-9.283,22.57466l4.45222,6.88072-4.9288-3.981a32.52249,32.52249,0,0,0-.27041,4.0782c0,13.74959,4.49056,24.89583,10.03,24.89583s10.03-11.14624,10.03-24.89583a42.818,42.818,0,0,0-2.29454-12.84723Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M525.74665,92.48079l6.24485-1.33818a80.386,80.386,0,0,0,3.375-8.40894l-2.86772-.30508,3.19738-.68514c1.15933-3.55352,1.70207-5.98014,1.70207-5.98014s-12.67374,2.83326-22.52676,9.39864l-1.71721,8.01359-.67022-6.30016a32.52414,32.52414,0,0,0-3.07493,2.69252c-9.72242,9.72242-14.4287,20.77932-10.51174,24.69627s14.97385-.78932,24.69627-10.51174a42.81769,42.81769,0,0,0,7.46188-10.70686Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M528.02764,145.68472c-14.48118.92631-30.25994-.05387-47.04589,0V107.25287c14.79122,2.30262,30.56472,2.06615,47.04589,0Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M631.62843,175.65222l2.26263-3.49679a52.42392,52.42392,0,0,0-2.32132-5.434l-1.46308,1.18172,1.15847-1.79036c-1.104-2.17326-1.97276-3.54253-1.97276-3.54253a50.2414,50.2414,0,0,0-6.05381,14.72187l2.90347,4.4872-3.21427-2.59615a21.20987,21.20987,0,0,0-.17635,2.65956c0,8.96667,2.92849,16.2356,6.541,16.2356s6.541-7.26893,6.541-16.2356a27.92338,27.92338,0,0,0-1.49636-8.37821Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M647.64364,183.42582l4.07252-.87269a52.42092,52.42092,0,0,0,2.201-5.48381l-1.87016-.199,2.08514-.44681c.756-2.31739,1.11-3.89989,1.11-3.89989a50.241,50.241,0,0,0-14.69062,6.12924l-1.11987,5.226-.43707-4.10859a21.20826,21.20826,0,0,0-2.00529,1.7559c-6.3404,6.34039-9.40955,13.55105-6.85515,16.10546s9.76507-.51475,16.10546-6.85515a27.92314,27.92314,0,0,0,4.8662-6.98238Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M649.13117,218.12229c-9.44378.60408-19.73376-.03513-30.68057,0v-25.063a110.58424,110.58424,0,0,0,30.68057,0Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M643.29962,292.39872c-8.33889.53341-17.425-.031-27.091,0V270.268a97.6466,97.6466,0,0,0,27.091,0Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 167.50834,
    y: 82.48131,
    width: 364.54703,
    height: 10.18288,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 167.50834,
    y: 154.77974,
    width: 364.54703,
    height: 10.18288,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 167.50834,
    y: 227.07818,
    width: 364.54703,
    height: 10.18288,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 470.9581,
    cy: 197.54783,
    r: 20.36576,
    fill: "#e6e6e6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.9581,
    cy: 197.54783,
    r: 16.2926,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 470.9581,
    cy: 197.54783,
    r: 4.07315,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 634.87636,
    y: 249.90225,
    width: 2.03658,
    height: 16.2926,
    transform: "translate(735.11638 -438.34681) rotate(90)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 628.76663,
    y: 243.79252,
    width: 2.03658,
    height: 16.2926,
    transform: "translate(1100.74302 443.37693) rotate(180)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 339.72544,
    y: 105.10421,
    width: 13.47506,
    height: 53.33878,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 339.72544,
    y: 113.52612,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 339.72544,
    y: 140.47624,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 318.95139,
    y: 105.10421,
    width: 13.47506,
    height: 53.33878,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 318.95139,
    y: 113.52612,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 318.95139,
    y: 140.47624,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 522.69507,
    y: 165.60493,
    width: 13.47506,
    height: 53.33878,
    transform: "translate(-189.17144 194.36555) rotate(-26.3396)",
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 515.96897,
    y: 175.60069,
    width: 13.47506,
    height: 6.17607,
    transform: "translate(-183.84194 189.97078) rotate(-26.3396)",
    fill: "#ccc"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 527.92649,
    y: 199.75285,
    width: 13.47506,
    height: 6.17607,
    transform: "translate(-193.3166 197.7837) rotate(-26.3396)",
    fill: "#ccc"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 219.56748,
    y: 177.40264,
    width: 13.47506,
    height: 53.33878,
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 219.56748,
    y: 185.82455,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 219.56748,
    y: 212.77467,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 198.79343,
    y: 177.40264,
    width: 13.47506,
    height: 53.33878,
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 198.79343,
    y: 185.82455,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 198.79343,
    y: 212.77467,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 402.53712,
    y: 237.90336,
    width: 13.47506,
    height: 53.33878,
    transform: "translate(-233.72439 148.5586) rotate(-26.3396)",
    fill: "#e6e6e6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 395.81101,
    y: 247.89913,
    width: 13.47506,
    height: 6.17607,
    transform: "translate(-228.39489 144.16384) rotate(-26.3396)",
    fill: "#ccc"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 407.76853,
    y: 272.05128,
    width: 13.47506,
    height: 6.17607,
    transform: "translate(-237.86955 151.97676) rotate(-26.3396)",
    fill: "#ccc"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 345.83517,
    y: 177.40264,
    width: 13.47506,
    height: 53.33878,
    fill: "#e6e6e6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 345.83517,
    y: 185.82455,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 345.83517,
    y: 212.77467,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 325.06112,
    y: 177.40264,
    width: 13.47506,
    height: 53.33878,
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 325.06112,
    y: 185.82455,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 325.06112,
    y: 212.77467,
    width: 13.47506,
    height: 6.17607,
    fill: "#ccc"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 528.8048,
    y: 237.90336,
    width: 13.47506,
    height: 53.33878,
    transform: "translate(-220.61527 204.58241) rotate(-26.3396)",
    fill: "#e6e6e6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 522.0787,
    y: 247.89913,
    width: 13.47506,
    height: 6.17607,
    transform: "translate(-215.28577 200.18764) rotate(-26.3396)",
    fill: "#ccc"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 534.03622,
    y: 272.05128,
    width: 13.47506,
    height: 6.17607,
    transform: "translate(-224.76043 208.00056) rotate(-26.3396)",
    fill: "#ccc"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 449.98737,
    y: 32.64567,
    width: 53.55594,
    height: 53.55594,
    fill: "#e6e6e6"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 460.69856,
    y: 43.35686,
    width: 32.13357,
    height: 32.13357,
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "470 54.143 476.814 65.944 483.627 77.745 470 77.745 456.373 77.745 463.187 65.944 470 54.143",
    fill: "#e6e6e6"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "481.839 56.398 488.653 68.199 495.466 80 481.839 80 468.212 80 475.026 68.199 481.839 56.398",
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 486.63091,
    cy: 48.99433,
    r: 3.94623,
    fill: "#e6e6e6"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 179.12282,
    y: 32.64567,
    width: 53.55594,
    height: 53.55594,
    fill: "#e6e6e6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 189.83401,
    y: 43.35686,
    width: 32.13357,
    height: 32.13357,
    fill: "#ccc"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.136 54.143 205.949 65.944 212.763 77.745 199.136 77.745 185.509 77.745 192.322 65.944 199.136 54.143",
    fill: "#e6e6e6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "210.975 56.398 217.788 68.199 224.601 80 210.975 80 197.348 80 204.161 68.199 210.975 56.398",
    fill: "#e6e6e6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.76636,
    cy: 48.99433,
    r: 3.94623,
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M230.32422,458.34544l3.46953-5.362a80.3871,80.3871,0,0,0-3.55953-8.33251l-2.24351,1.812,1.77642-2.74534c-1.69294-3.3325-3.02505-5.43215-3.02505-5.43215s-6.95827,10.96511-9.283,22.57466l4.45222,6.88072-4.92881-3.981a32.52438,32.52438,0,0,0-.27041,4.0782c0,13.74959,4.49057,24.89583,10.03,24.89583s10.03-11.14624,10.03-24.89583a42.818,42.818,0,0,0-2.29454-12.84723Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#6c63ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M254.8821,470.26556l6.24485-1.33818a80.386,80.386,0,0,0,3.375-8.40894l-2.86772-.30508,3.19737-.68514c1.15934-3.55352,1.70208-5.98014,1.70208-5.98014s-12.67374,2.83326-22.52676,9.39864l-1.71721,8.01359-.67022-6.30016a32.52414,32.52414,0,0,0-3.07493,2.69252c-9.72243,9.72242-14.4287,20.77932-10.51175,24.69627s14.97385-.78932,24.69628-10.51174a42.818,42.818,0,0,0,7.46188-10.70686Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#6c63ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M257.16309,523.46949c-14.48118.92631-30.25994-.05387-47.04589,0V485.03764c14.79122,2.30262,30.56472,2.06615,47.04589,0Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#3f3d56"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 500.99759,
    y: 475.03125,
    width: 195.51126,
    height: 253.55366,
    fill: "#e6e6e6"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 92.66419,
    y: 488.269,
    width: 10.18288,
    height: 240.31592,
    fill: "#e6e6e6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    y: 457.72036,
    width: 696.50885,
    height: 20.36576,
    fill: "#e6e6e6"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 87.57275,
    y: 478.08612,
    width: 20.36576,
    height: 20.36576,
    fill: "#e6e6e6"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "614.155 489.796 613.009 494.379 584.497 494.379 582.779 489.796 510.162 489.796 510.162 536.638 687.344 536.638 687.344 489.796 614.155 489.796",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "614.155 548.857 613.009 553.439 584.497 553.439 582.779 548.857 510.162 548.857 510.162 595.698 687.344 595.698 687.344 548.857 614.155 548.857",
    fill: "#3f3d56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "614.155 607.918 613.009 612.5 584.497 612.5 582.779 607.918 510.162 607.918 510.162 654.759 687.344 654.759 687.344 607.918 614.155 607.918",
    fill: "#3f3d56"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "614.155 666.979 613.009 671.561 584.497 671.561 582.779 666.979 510.162 666.979 510.162 713.82 687.344 713.82 687.344 666.979 614.155 666.979",
    fill: "#3f3d56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "377.785 454.665 317.706 454.665 319.742 428.19 375.748 428.19 377.785 454.665",
    fill: "#e6e6e6"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 314.65093,
    y: 451.61063,
    width: 67.20699,
    height: 6.10973,
    fill: "#e6e6e6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M621.63862,318.12753H392.01472a6.10973,6.10973,0,0,0-6.10973,6.10973V464.25183H627.74834V324.23726A6.10973,6.10973,0,0,0,621.63862,318.12753Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.905,464.25183V487.1633a6.10973,6.10973,0,0,0,6.10973,6.10973h229.6239a6.10973,6.10973,0,0,0,6.10972-6.10973V464.25183Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 239.29763,
    y: 270.35541,
    width: 217.91359,
    height: 122.19453,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.25442,
    cy: 418.00714,
    r: 6.10973,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.86229,787.5582c-22.25416,1.42352-46.50239-.08278-72.29843,0V728.49751c22.73061,3.53859,46.97076,3.17519,72.29843,0Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "831.432 673.3 825.322 673.3 827.359 553.949 829.395 553.949 831.432 673.3",
    fill: "#3f3d56"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "858.926 674.107 852.816 674.107 854.853 554.755 856.889 554.755 858.926 674.107",
    fill: "#3f3d56"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "806.993 674.107 800.883 674.107 802.92 554.755 804.956 554.755 806.993 674.107",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M995.35023,538.07769l9.8628-15.24249a228.51376,228.51376,0,0,0-10.11861-23.68669l-6.3776,5.1511,5.0498-7.80416c-4.81251-9.47323-8.59926-15.44187-8.59926-15.44187s-19.78017,31.17033-26.3886,64.17264L971.435,564.78593l-14.011-11.31664a92.45186,92.45186,0,0,0-.76869,11.593c0,39.08574,12.76527,70.771,28.51206,70.771s28.512-31.68526,28.512-70.771c0-12.117-2.74124-24.794-6.52266-36.52063Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#e6e6e6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.844,540.11427l9.8628-15.2425a228.5147,228.5147,0,0,0-10.11861-23.68669l-6.3776,5.15111,5.0498-7.80416c-4.81251-9.47323-8.59926-15.44188-8.59926-15.44188s-19.78017,31.17034-26.3886,64.17264l12.65626,19.55972-14.011-11.31664a92.45186,92.45186,0,0,0-.76869,11.593c0,39.08574,12.76527,70.771,28.51206,70.771s28.51206-31.68526,28.51206-70.771c0-12.117-2.74125-24.794-6.52267-36.52064Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#6c63ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M970.91133,540.11427l9.8628-15.2425a228.51678,228.51678,0,0,0-10.11862-23.68669l-6.3776,5.15111,5.0498-7.80416c-4.8125-9.47323-8.59926-15.44188-8.59926-15.44188s-19.78017,31.17034-26.3886,64.17264l12.65626,19.55972-14.011-11.31664a92.45186,92.45186,0,0,0-.76869,11.593c0,39.08574,12.76527,70.771,28.51206,70.771s28.51206-31.68526,28.51206-70.771c0-12.117-2.74125-24.794-6.52266-36.52064Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#6c63ff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 309.96395,
    y: 304.84783,
    width: 58.75616,
    height: 3.37283,
    fill: "#3f3d56"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 309.96395,
    y: 317.15098,
    width: 90.7323,
    height: 3.37283,
    fill: "#6c63ff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 309.96395,
    y: 328.74233,
    width: 73.94482,
    height: 3.37283,
    fill: "#6c63ff"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 309.96395,
    y: 340.28988,
    width: 43.16779,
    height: 3.37283,
    fill: "#3f3d56"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 309.96395,
    y: 351.83743,
    width: 65.15139,
    height: 3.37283,
    fill: "#3f3d56"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 283.18393,
    y: 303.64873,
    width: 7.19463,
    height: 7.19463,
    fill: "#3f3d56"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 283.18393,
    y: 315.24008,
    width: 7.19463,
    height: 7.19463,
    fill: "#6c63ff"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 283.18393,
    y: 326.83143,
    width: 7.19463,
    height: 7.19463,
    fill: "#6c63ff"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 283.18393,
    y: 338.42278,
    width: 7.19463,
    height: 7.19463,
    fill: "#3f3d56"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 283.18393,
    y: 350.01413,
    width: 7.19463,
    height: 7.19463,
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M605.94216,358.96335H575.109a107.84044,107.84044,0,0,1,0-36.76267h30.8332A66.14839,66.14839,0,0,0,605.94216,358.96335Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#6c63ff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M381.59071,432.64519l-12.68484-3.092a32.65651,32.65651,0,0,1-32.05067-39.12409v0a42.68467,42.68467,0,0,1,42.631-42.73825h.00008a42.68468,42.68468,0,0,1,42.73825,42.631v.00006C429.41674,415.35014,406.89108,438.81238,381.59071,432.64519Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 236.61974,
    cy: 345.24334,
    r: 31.36369,
    fill: "#ffb8b8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M374.992,422.10773s-9.54547,32.72733-15,35.4546,43.63644,6.8182,43.63644,6.8182-1.36364-31.36369,1.36364-34.091S374.992,422.10773,374.992,422.10773Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M424.083,623.92626s61.36374-5.45456,69.54557,15S488.174,780.74471,488.174,780.74471H462.26485V681.19908s-110.4725-31.40179-110.4725-42.31089S424.083,623.92626,424.083,623.92626Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M484.08307,775.29015l13.63639,5.45456s16.36366-1.36364,9.54547,10.90911A27.00366,27.00366,0,0,1,488.174,805.29021s-25.90914,9.54547-27.27278,0,6.8182-28.63642,6.8182-28.63642Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M389.992,623.92626s61.36374-5.45456,69.54557,15S454.083,780.74471,454.083,780.74471H428.17388V681.19908s-78.4181-18.164-78.4181-29.07315c0-5.12492-5.34348-31.171,4.07315-36.65836C364.45693,609.27432,389.992,623.92626,389.992,623.92626Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#2f2e41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9921,775.29015l13.63639,5.45456s16.36367-1.36364,9.54547,10.90911A27.00366,27.00366,0,0,1,454.083,805.29021s-25.90914,9.54547-27.27277,0,6.81819-28.63642,6.81819-28.63642Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#2f2e41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M361.35559,453.47142l40.98018,4.45436a30.18224,30.18224,0,0,1,26.26893,23.76669L444.53755,557.108s5.45455,75.00013-5.45456,79.091-25.90913-16.36366-46.36371-13.63638-47.04554,8.86365-47.04554,8.86365S341.451,497.179,340.901,486.19875C339.80142,464.24769,361.35559,453.47142,361.35559,453.47142Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#575a89"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.42733,627.82255l16.82365,9.9078s30.18279-4.33064,29.24058,6.278-33.8887,8.55886-33.8887,8.55886l-20.275-12.493Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#ffb8b8"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.7429,
    cy: 299.47504,
    r: 20.25966,
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M353.26293,349.08471a20.2502,20.2502,0,0,0-24.24652-19.836,20.25023,20.25023,0,1,1,12.63025,38.16451A20.243,20.243,0,0,0,353.26293,349.08471Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#2f2e41"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M370.64347,360.57471l27.313-5.02907,21.00491,13.16494a31.86273,31.86273,0,0,1,14.6776,31.09515l-21.0372-5.33225-4.71074-11.81208-5.61047,9.196-29.33406,37.75029-16.46978-10.48815-14.68292-23.00931Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M393.13569,465.07123l13.63639-6.8182s28.63641,4.09092,34.091,23.18186,30,151.3639,30,151.3639L447.68124,643.7079l-32.72733-80.45468Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#575a89"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.917 458.23 259.565 511.205 283.767 570.701 282.928 572.761 254.063 512.199 245.917 458.23",
    opacity: 0.2
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "144.084 750.379 139.271 748.721 185.896 610.231 192.636 612.553 144.084 750.379",
    fill: "#3f3d56"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.291 750.379 327.105 748.721 280.479 610.231 273.74 612.553 322.291 750.379",
    fill: "#3f3d56"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.77 778.981 228.861 778.999 230.443 617.107 223.315 617.082 223.77 778.981",
    fill: "#3f3d56"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M291.12655,589.35709l13.96582,56.44513a44.82625,44.82625,0,0,0,32.64214,32.72145l.00008,0a238.26046,238.26046,0,0,0,118.54694-.7638l20.8512-5.49922c12.11558-3.19531,21.22652-13.60111,22.0886-26.10127a25.68469,25.68469,0,0,0-2.323-12.8718q-.12219-.25966-.24559-.51476a34.06444,34.06444,0,0,0-29.59817-19.13845l-22.08892-.71254L364.521,577.28177s-27.66705-14.0531-50.4117-15.62629C299.08852,560.61654,287.51024,574.74121,291.12655,589.35709Z",
    transform: "translate(-158.82681 -60.50072)",
    fill: "#6c63ff"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 543.25654,
    y: 351.30929,
    width: 79.42645,
    height: 107.93851,
    fill: "#e6e6e6"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 552.42113,
    y: 363.76373,
    width: 61.09727,
    height: 83.02962,
    fill: "#fff"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 576.46734,
    y: 385.49176,
    width: 29.60198,
    height: 3.37283,
    fill: "#3f3d56"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 559.8702,
    y: 383.62466,
    width: 7.19463,
    height: 7.19463,
    fill: "#3f3d56"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 576.46734,
    y: 399.74779,
    width: 29.60198,
    height: 3.37283,
    fill: "#3f3d56"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 559.8702,
    y: 397.88069,
    width: 7.19463,
    height: 7.19463,
    fill: "#3f3d56"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 576.46734,
    y: 414.00382,
    width: 29.60198,
    height: 3.37283,
    fill: "#3f3d56"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 559.8702,
    y: 412.13672,
    width: 7.19463,
    height: 7.19463,
    fill: "#3f3d56"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 579.9149,
    y: 354.36415,
    width: 6.10973,
    height: 6.10973,
    rx: 3.05486,
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.c32d0b1852c09cad7ec0c2b48c389957.svg";
export { ForwardRef as ReactComponent };